import React, { useRef } from 'react';
import { useDrop } from 'react-dnd';
import { Box } from '@ghq-abi/design-system-v2';

import { DroppableProps } from './types';

// Define the droppable component
export function Droppable<T>({ onDrop, children, item }: DroppableProps<T>) {
  const ref = useRef<HTMLDivElement>(null);
  const [, dropRef] = useDrop({
    accept: item.type, // Replace with your specific item type
    drop: (target: T) => {
      onDrop(target);
    }
  });

  dropRef(ref);

  return <Box ref={ref}>{children}</Box>;
}
